export enum MEASURES_NAMES {
  BOOT = 'booting_time',
  ROOT_MODULE = 'root_module_time',
  DASHBOARD_MODULE = 'dashboard_module_time',
  COMPLIANCE_MODULE_TIME = 'compliance_module_time',
  CSA_ACTIVITY_MODULE_TIME = 'csa_activity_module_time',
  CSA_INSPECTION_MODULE_TIME = 'csa_inspection_module_time',
  DISCONNECTS_MODULE_TIME = 'disconnects_module_time',
  DISCONNECTS_LIST_MODULE_TIME = 'disconnects_list_module_time',
  DISCONNECT_DETAILS_MODULE_TIME = 'disconnect_details_module_time',
  DISCONNECT_UPGRADE_MODULE_TIME = 'disconnect_upgrade_module_time',
  DRIVERS_SELECT_LIST_LOAD_TIME = 'drivers_select_list_load_time',
  BOOT_TO_FLEETVIEW_TRAVEL_GROUPS_MODULE = 'boot_to_fleetview_travel_groups_module_time',
  FACE_MATCH_MODULE_TIME = 'face_match_module_time',
  LOGS_MODULE_TIME = 'logs_module_time',
  LOGS_EDIT_MODULE_TIME = 'logs_edit_module_time',
  LOGS_LIST_MODULE_TIME = 'logs_list_module_time',
  LOG_DETAILS_MODULE_TIME = 'log_details_module_time',
  TRIPS_MODULE_TIME = 'trips_module_time',
  TRIPS_LIST_MODULE_TIME = 'trips_list_module_time',
  TRIP_DETAILS_MODULE_TIME = 'trip_details_module_time',
  COMPLIANCE_DRIVING_EVENTS_LIST_MODULE_TIME = 'compliance_driving_events_list_module_time',
  COMPLIANCE_DRIVING_EVENTS_DETAIL_MODULE_TIME = 'compliance_driving_events_detail_module_time',
  FLEETVIEW_FIRST_MODULE_TO_TRAVEL_GROUPS_COMPONENT = 'fleetview_first_module_to_travel_groups_component',
  FLEETVIEW_MODULE = 'fleetview_module_time',
  FLEETVIEW_MAP_MODULE = 'fleetview_map_module_time',
  FLEETVIEW_TRAVEL_GROUPS_MODULE = 'fleetview_travel_groups_module_time',
  FLEETVIEW_TRAVEL_GROUPS_DETAILS_MODULE = 'fleetview_travel_groups_module_time',
  FLEETVIEW_LIST_AREA_READY_TO_PAINT_TIME = 'fleetview_list_area_ready_to_paint_time',
  FLEETVIEW_LIST_AREA_RENDERING_TIME = 'fleetview_list_area_rendering_time',
  FLEETVIEW_LIST_AREA_FULLY_LOADED = 'fleetview_list_area_loaded_time',
  FLEETVIEW_VEHICLE_DETAIL_LOADED = 'fleetview_vehicle_detail_loaded',
  FLEETVIEW_DRIVER_DETAIL_LOADED = 'fleetview_driver_detail_loaded',
  FLEETVIEW_MAP_AREA_FULLY_LOADED = 'fleetview_map_area_loaded_time',
  FLEETVIEW_MAP_INITIALIZED= 'fleetview_map_initialization_loaded_time',
  FLEETVIEW_MAP_UI_SECTION_INITIALIZED= 'fleetview_map_ui_section_initialization_loaded_time',
  FLEETVIEW_MAP_MARKERS_READY_TO_PAINT_LOADED_TIME = 'fleetview_map_markers_ready_to_paint_loaded_time',
  FLEETVIEW_MAP_MARKERS_LOADED = 'fleetview_map_markers_loaded_time',
  DOCUMENTS_MODULE = 'documents_module_time',
  REPORTS_MODULE = 'reports_module_time',
  REPORTS_TO_MAIN = 'reports_to_main_component_time',
  BOOT_TO_REPORTS_MODULE = 'boot_to_reports_module_time',
  BOOT_TO_DASHBOARD = 'boot_to_dashboard_module_time',
  GENERAL = 'WebApp Loading Times Measures',
  MAINTENANCE_MODULE = 'maintenance_module_time',
  MAINTENANCE_INSPECTION_COMPONENT = 'maintenacne_inspection_component_time',
  SAFETY_MODULE = 'safety_module_time',
  SAFETY_OVERVIEW_MODULE = 'safety_overview_module_time',
  SAFETY_COACHING_MODULE = 'safety_coaching_module_time',
  SAFETY_COACHING_SESSION_MODULE = 'safety_coaching_session_module_time',
  SAFETY_DRIVERS_MODULE = 'safety_drivers_module_time',
  SAFETY_DRIVERS_DETAIL_MODULE = 'safety_drivers_detail_module_time',
  SAFETY_EVENTS_MODULE = 'safety_events_module_time',
  SAFETY_EVENTS_DETAIL_MODULE = 'safety_events_detail_module_time',
  SAFETY_SPEEDING_MODULE = 'safety_speeding_module_time',
  SAFETY_SPEEDING_DETAIL_MODULE = 'safety_speeding_detail_module_time',
  SAFETY_REQUESTS_MODULE = 'safety_requests_module_time',
  SAFETY_REQUESTS_DETAIL_MODULE = 'safety_requests_detail_module_time',
  SAFETY_INSIGHTS_MODULE = 'safety_insights_module_time',
  SAFETY_CAMERAS_MODULE = 'safety_cameras_module_time',
  SAFETY_DRIVERS_DETAIL_LOADING_TIME = 'safety_drivers_detail_loading_time',
  FLEET_CARDS_DASHBOARD_MODULE = 'fleetcards_dashboard_module_time',
  FLEET_CARDS_ADMIN_MODULE = 'fleetcards_admin_module_time',
  INDEX_EJS_LOADTIME = 'index_ejs_load_time',
  BOOT_START_TO_VALIDATE_START_TIME = 'boot_start_to_validate_start_time',
  VALIDATE_API_TIME = 'validate_api_time',
  VALIDATE_GET_API_START_TIME = 'validate_get_api_start_time',
  VALIDATE_GET_API_END_TIME = 'validate_get_api_end_time',
  VALIDATE_GET_API_DURATION = 'validate_get_api_duration',
  VALIDATE_RESPONSE_EVENT_TIMER = 'validate_response_event_timer',
  STATSIG_I18N_SEMANTIC_PROMISE_DURATION = 'statsig_i18n_semantic_promise_duration',
  BOOTSTART_PROMISE_ALL_CALL_DURATION = 'boot_start_promise_all_call_duration',
  STATSIG_INIT_CALL_START_TIME = 'statsig_init_call_start_time',
  // Measures that are used independently from performance logging
  TABLEAU_REPORT_FULLY_LOADED = 'tableau_report_loaded_time',
  FUEL_MODULE = 'fuel_module_time',
  FLEET_VIEW_BETA_COUNTRY_CLUSTERS_LOAD_TIME = 'fleet-view-beta-country-clusters-load-time',
  FLEET_VIEW_BETA_STATE_CLUSTERS_LOAD_TIME = 'fleet-view-beta-state-clusters-load-time',
  FLEET_VIEW_BETA_CLIENT_CLUSTERS_LOAD_TIME = 'fleet-view-beta-client-clusters-load-time',
  FLEET_VIEW_BETA_MARKERS_LOAD_TIME = 'fleet-view-beta-markers-load-time',
  FLEETVIEW_BETA_INITIAL_LOAD_COUNTRY_CLUSTERS = 'fleetview-beta-initial-load-country-clusters',
  FLEETVIEW_BETA_INITIAL_LOAD_STATE_CLUSTERS = 'fleetview-beta-initial-load-state-clusters',
  FLEETVIEW_BETA_INITIAL_LOAD_CLIENT_CLUSTERING = 'fleetview-beta-initial-load-client-clustering',
  FLEETVIEW_BETA_INITIAL_LOAD_INDIVIDUAL_MARKERS = 'fleetview-beta-initial-load-individual-markers',
  FLEETVIEW_BETA_ROUTE_CHANGE_COUNTRY_CLUSTERS = 'fleetview-beta-route-change-country-clusters',
  FLEETVIEW_BETA_ROUTE_CHANGE_STATE_CLUSTERS = 'fleetview-beta-route-change-state-clusters',
  FLEETVIEW_BETA_ROUTE_CHANGE_CLIENT_CLUSTERING = 'fleetview-beta-route-change-client-clustering',
  FLEETVIEW_BETA_ROUTE_CHANGE_INDIVIDUAL_MARKERS = 'fleetview-beta-route-change-individual-markers',
  FLEETVIEW_BETA_ROUTE_CHANGE_TIME = 'fleetview-beta-route-change-time',
  FLEETVIEW_BETA_MAP_PAGE_MODULE = 'fleetview-beta-map-page-module-time',
  FLEETVIEW_PAGINATED_VEHICLES_API_RESPONSE = 'fleetview-paginated-vehicles-api-response-time',
  FLEETVIEW_PAGINATED_ALL_PAGES_LOADED = 'fleetview-paginated-all-pages-loaded-time',
}

export enum MARKERS {
  ROOT_MODULE_START = 'root-module-start',
  ROOT_MODULE_END = 'root-module-end',
  BOOT_START = 'boot-start',
  BOOT_END = 'boot-end',
  COMPLIANCE_MODULE_START = 'compliance-module-start',
  COMPLIANCE_MODULE_END = 'compliance-module-end',
  DRIVER_SELECT_LIST_LOAD_START = 'driver_select_list_load_start',
  DRIVER_SELECT_LIST_LOAD_END = 'driver_select_list_load_end',
  CSA_ACTIVITY_MODULE_START = 'csa-activity-module-start',
  CSA_ACTIVITY_MODULE_END = 'csa-activity-module-end',
  CSA_INSPECTION_MODULE_START = 'csa-inspection-module-start',
  CSA_INSPECTION_MODULE_END = 'csa-inspection-module-end',
  DISCONNECTS_MODULE_START = 'disconnects-module-start',
  DISCONNECTS_MODULE_END = 'disconnects-module-end',
  DISCONNECTS_LIST_MODULE_START = 'disconnects-list-module-start',
  DISCONNECTS_LIST_MODULE_END = 'disconnects-list-module-end',
  DISCONNECT_DETAILS_MODULE_START = 'disconnect-details-module-start',
  DISCONNECT_DETAILS_MODULE_END = 'disconnect-details-module-end',
  DISCONNECT_UPGRADE_MODULE_START = 'disconnect-upgrade-module-start',
  DISCONNECT_UPGRADE_MODULE_END = 'disconnect-upgrade-module-end',
  LOGS_MODULE_START = 'logs-module-start',
  LOGS_MODULE_END = 'logs-module-end',
  LOGS_EDIT_MODULE_START = 'logs-edit-module-start',
  LOGS_EDIT_MODULE_END = 'logs-edit-module-end',
  LOGS_LIST_MODULE_START = 'logs_list_module_start',
  LOGS_LIST_MODULE_END = 'logs_list_module_end',
  LOG_DETAILS_MODULE_START = 'log-details-module-start',
  LOG_DETAILS_MODULE_END = 'log-details-module-end',
  TRIPS_MODULE_START = 'trips-module-start',
  TRIPS_MODULE_END = 'trips-module-end',
  TRIPS_LIST_MODULE_START = 'trips-list-module-start',
  TRIPS_LIST_MODULE_END = 'trips-list-module-end',
  TRIP_DETAILS_MODULE_START = 'trip-details-module-start',
  TRIP_DETAILS_MODULE_END = 'trip-details-module-end',
  COMPLIANCE_DRIVING_EVENTS_LIST_MODULE_START = 'compliance-driving-events-list-module-start',
  COMPLIANCE_DRIVING_EVENTS_LIST_MODULE_END = 'compliance-driving-events-list-module-end',
  COMPLIANCE_DRIVING_EVENTS_DETAIL_MODULE_START = 'compliance-driving-events-detail-module-start',
  COMPLIANCE_DRIVING_EVENTS_DETAIL_MODULE_END = 'compliance-driving-events-detail-module-end',
  DASHBOARD_MODULE_START = 'dashboard-module-start',
  DASHBOARD_MODULE_END = 'dashboard-module-end',
  FACE_MATCH_MODULE_START = 'face-match-module-start',
  FACE_MATCH_MODULE_END = 'face-match-module-end',
  FLEETVIEW_MODULE_START = 'fleetview-module-start',
  FLEETVIEW_MODULE_END = 'fleetview-module-end',
  FLEETVIEW_MAP_MODULE_START = 'fleetview-map-module-start',
  FLEETVIEW_MAP_MODULE_END = 'fleetview-map-module-end',
  FLEETVIEW_TRAVEL_GROUPS_MODULE_START = 'fleetview-travel_groups-module-start',
  FLEETVIEW_TRAVEL_GROUPS_MODULE_END = 'fleetview-travel_groups-module-end',
  FLEETVIEW_TRAVEL_GROUPS_DETAILS_MODULE_START = 'fleetview-travel_groups-details-module-start',
  FLEETVIEW_TRAVEL_GROUPS_DETAILS_MODULE_END = 'fleetview-travel_groups-details-module-end',
  FLEETVIEW_MAP_AREA_RENDERING_END = 'fleetview-map-area-rendering-end',
  FLEETVIEW_MAP_INITIALIZATION_START = 'fleetview-map-initialization-start',
  FLEETVIEW_MAP_INITIALIZATION_END = 'fleetview-map-initialization-end',
  FLEETVIEW_MAP_MARKERS_READY_TO_PAINT_END = 'fleetview-map-markers-ready-to-paint-end',
  FLEETVIEW_MAP_MARKERS_RENDERING_END = 'fleetview-map-markers-rendering-end',
  FLEETVIEW_LIST_READY_TO_PAINT = 'fleetview-list-ready-to-paint',
  FLEETVIEW_LIST_RENDERING_END = 'fleetview-list-rendering-end',
  FLEETVIEW_VEHICLE_DETAIL_RENDER_START_TIME = 'fleetview_vehicle_detail_render_start_time',
  FLEETVIEW_VEHICLE_DETAIL_RENDER_END_TIME = 'fleetview_vehicle_detail_render_end_time',
  FLEETVIEW_DRIVER_DETAIL_RENDER_START_TIME = 'fleetview_driver_detail_render_start_time',
  FLEETVIEW_DRIVER_DETAIL_RENDER_END_TIME = 'fleetview_driver_detail_render_end_time',
  FLEETVIEW_TRAVEL_GROUPS_COMPONENT_END = 'fleetview-travel-groups-component-end',
  DOCUMENTS_MODULE_START = 'documents-module-start',
  DOCUMENTS_MODULE_END = 'documents-module-end',
  REPORTS_MODULE_START = 'reports-module-start',
  REPORTS_MODULE_END = 'reports-module-end',
  REPORTS_MAIN_COMPONENT_START = 'reports-component-start',
  REPORTS_MAIN_COMPONENT_END = 'reports-component-end',
  MAINTENANCE_MODULE_START = 'maintenance-module-start',
  MAINTENANCE_MODULE_END = 'maintenance-module-end',
  SAFETY_MODULE_START = 'safety-module-start',
  SAFETY_MODULE_END = 'safety-module-end',
  SAFETY_OVERVIEW_MODULE_START = 'safety-overview-module-start',
  SAFETY_OVERVIEW_MODULE_END = 'safety-overview-module-end',
  SAFETY_COACHING_MODULE_START = 'safety-coaching-module-start',
  SAFETY_COACHING_MODULE_END = 'safety-coaching-module-end',
  SAFETY_COACHING_SESSION_MODULE_START = 'safety-coaching-session-module-start',
  SAFETY_COACHING_SESSION_MODULE_END = 'safety-coaching-session-module-end',
  SAFETY_DRIVERS_MODULE_START = 'safety-drivers-module-start',
  SAFETY_DRIVERS_MODULE_END = 'safety-drivers-module-end',
  SAFETY_DRIVERS_DETAIL_MODULE_START = 'safety-drivers-detail-module-start',
  SAFETY_DRIVERS_DETAIL_MODULE_END = 'safety-drivers-detail-module-end',
  SAFETY_EVENTS_MODULE_START = 'safety-events-module-start',
  SAFETY_EVENTS_MODULE_END = 'safety-events-module-end',
  SAFETY_EVENTS_DETAIL_MODULE_START = 'safety-events-detail-module-start',
  SAFETY_EVENTS_DETAIL_MODULE_END = 'safety-events-detail-module-end',
  SAFETY_SPEEDING_MODULE_START = 'safety-speeding-module-start',
  SAFETY_SPEEDING_MODULE_END = 'safety-speeding-module-end',
  SAFETY_SPEEDING_DETAIL_MODULE_START = 'safety-speeding-detail-module-start',
  SAFETY_SPEEDING_DETAIL_MODULE_END = 'safety-speeding-detail-module-end',
  SAFETY_REQUESTS_MODULE_START = 'safety-requests-module-start',
  SAFETY_REQUESTS_MODULE_END = 'safety-requests-module-end',
  SAFETY_REQUESTS_DETAIL_MODULE_START = 'safety-requests-detail-module-start',
  SAFETY_REQUESTS_DETAIL_MODULE_END = 'safety-requests-detail-module-end',
  SAFETY_INSIGHTS_MODULE_START = 'safety-insights-module-start',
  SAFETY_INSIGHTS_MODULE_END = 'safety-insights-module-end',
  SAFETY_CAMERAS_MODULE_START = 'safety-cameras-module-start',
  SAFETY_CAMERAS_MODULE_END = 'safety-cameras-module-end',
  SAFETY_DRIVERS_DETAIL_LOADING_TIME_START = 'safety-drivers-detail-loading-time-start',
  SAFETY_DRIVERS_DETAIL_LOADING_TIME_END = 'safety-drivers-detail-loading-time-end',
  FLEET_CARDS_DASHBOARD_MODULE_START = 'fleetcards-dashboard-module-start',
  FLEET_CARDS_DASHBOARD_MODULE_END = 'fleetcards-dashboard-module-end',
  FLEET_CARDS_ADMIN_MODULE_START = 'fleetcards-admin-module-start',
  FLEET_CARDS_ADMIN_MODULE_END = 'fleetcards-admin-module-end',
  VALIDATE_CALL_START = 'validate-call-start',
  VALIDATE_CALL_END = 'validate-call-end',
  VALIDATE_RESPONSE_EVENT_TIMER_START = 'validate-response-event-timer-start',
  VALIDATE_RESPONSE_EVENT_TIMER_END = 'validate-response-event-timer-end',
   FUEL_MODULE_START = 'fuel-module-start',
  FUEL_MODULE_END = 'fuel-module-end',
  FUEL_OVERVIEW_MODULE_START = 'fuel-overview-module-start',
  FUEL_OVERVIEW_MODULE_END = 'fuel-overview-module-end',
  FUEL_OVERVIEW_REVAMP_MODULE_START = 'fuel-overview-revamp-module-start',
  FUEL_OVERVIEW_REVAMP_MODULE_END = 'fuel-overview-revamp-module-end',
  FUEL_IDLING_MODULE_START = 'fuel-idling-module-start',
  FUEL_IDLING_MODULE_END = 'fuel-idling-module-end',
  FUEL_VEHICLES_MODULE_START = 'fuel-vehicles-module-start',
  FUEL_VEHICLES_MODULE_END = 'fuel-vehicles-module-end',
  STATSIG_INIT_CALL_START = 'statsig_init_call_start',
  BOOT_TS_PROMISE_ALL_START = 'boot_promise_all_start',
  BOOT_TS_PROMISE_ALL_END = 'boot_promise_all_end',
  // Markers that are used independently from performance logging
  TABLEAU_REPORT_INITIATED = 'tableau-report-initiated',
  FLEETVIEW_BETA_MAP_PAGE_MODULE_START = 'fleetview-beta-map-page-module-start',
  FLEETVIEW_BETA_MAP_PAGE_MODULE_END = 'fleetview-beta-map-page-module-end',
  FLEET_VIEW_BETA_COUNTRY_CLUSTERS_LOAD_START = 'fleet-view-beta-country-clusters-load-start',
  FLEET_VIEW_BETA_COUNTRY_CLUSTERS_LOAD_END = 'fleet-view-beta-country-clusters-load-end',
  FLEET_VIEW_BETA_STATE_CLUSTERS_LOAD_START = 'fleet-view-beta-state-clusters-load-start',
  FLEET_VIEW_BETA_STATE_CLUSTERS_LOAD_END = 'fleet-view-beta-state-clusters-load-end',
  FLEET_VIEW_BETA_CLIENT_CLUSTERS_LOAD_START = 'fleet-view-beta-client-cluster-load-start',
  FLEET_VIEW_BETA_CLIENT_CLUSTERS_LOAD_END = 'fleet-view-beta-client-cluster-load-end',
  FLEET_VIEW_BETA_MARKERS_LOAD_START = 'fleet-view-beta-markers-load-start',
  FLEET_VIEW_BETA_MARKERS_LOAD_END = 'fleet-view-beta-markers-load-end',
  FLEETVIEW_BETA_FIRST_MODULE_START = 'fleetview-beta-first-module-start',
  FLEETVIEW_BETA_ROUTE_CHANGE_START = 'fleetview-beta-route-change-start',
  FLEETVIEW_BETA_ROUTE_CHANGE_END = 'fleetview-beta-route-change-end',
  FLEETVIEW_PAGINATED_VEHICLES_API_START = 'fleetview-paginated-vehicles-api-start',
  FLEETVIEW_PAGINATED_VEHICLES_API_END = 'fleetview-paginated-vehicles-api-end',
  FLEETVIEW_PAGINATED_ALL_PAGES_LOADED_START = 'fleetview-paginated-all-pages-loaded-start',
  FLEETVIEW_PAGINATED_ALL_PAGES_LOADED_END = 'fleetview-paginated-all-pages-loaded-end',
}

export enum LOG_TYPES {
  BOOT = 'boot',
  PAGE = 'page',
}

export interface IConfig {
  clearMarkers?: boolean,
  log?: boolean,
  flush?: boolean,
}

export interface ILog {
  [key: string]: number,
}

type logType = LOG_TYPES.BOOT | LOG_TYPES.PAGE;

const DEFAULT_MEASURE_CONFIG: IConfig = { clearMarkers: true, log: true, flush: false };

export class LoadTimeLogger {
  static bootingLoadTimeLogs: ILog = {};
  static pageLoadTimeLogs: ILog = {};
  private static loadTimeLogsBuffer: ILog = {};

  private type: logType;

  public get getLoadTimeLoadObject(): ILog {
    if (this.type === LOG_TYPES.BOOT) return LoadTimeLogger.bootingLoadTimeLogs;
    if (this.type === LOG_TYPES.PAGE) return LoadTimeLogger.pageLoadTimeLogs;
    return {};
  }

  constructor(private loggerType: logType = LOG_TYPES.PAGE) {
    this.type = this.loggerType;
  }

  private handleMeasure(key: string, value: any, config: IConfig): void {
    if (config.log) this.addLog(key, value);
    if (config.flush) this.flushPageLoadTimeLogs([key]);
  }

  public flushPageLoadTimeLogs(measureNames: string[] = []): void {
    if (!measureNames.length) {
      LoadTimeLogger.loadTimeLogsBuffer = { ...LoadTimeLogger.loadTimeLogsBuffer, ...LoadTimeLogger.pageLoadTimeLogs };
      LoadTimeLogger.pageLoadTimeLogs = {};
    } else {
      measureNames.forEach((name: string): void => {
        const measureValue: number = LoadTimeLogger.pageLoadTimeLogs[name];
        if (measureValue === undefined) return;
        LoadTimeLogger.loadTimeLogsBuffer[name] = measureValue;
        delete LoadTimeLogger.pageLoadTimeLogs[name];
      });
    }
  }

  public getAllLogs(clear: boolean = false): ILog {
    const allMeasures = {
      ...LoadTimeLogger.bootingLoadTimeLogs,
      ...LoadTimeLogger.loadTimeLogsBuffer,
    };

    if (clear) {
      LoadTimeLogger.loadTimeLogsBuffer = {};
    }
    return allMeasures;
  }

  public addLog(key: string, value: number): ILog {
    this.getLoadTimeLoadObject[key] = value;
    return this.getLoadTimeLoadObject;
  }

  public measureFromMarker(
    startMarker: string,
    endMarker: string,
    measureName: string,
    config: IConfig = DEFAULT_MEASURE_CONFIG,
  ): number {
    config = { ...DEFAULT_MEASURE_CONFIG, ...config };
    try {
      const measure: any = window.performance.measure(measureName, startMarker, endMarker);
      this.handleMeasure(measure['name'], measure['duration'], config);
      if (config.clearMarkers) {
        window.performance.clearMarks(startMarker);
        window.performance.clearMarks(endMarker);
      }
      return measure['duration'];
    } catch (e) {
      console.error(e);
      return 0;
    }
  }

}